<template>
  <div id="footer" class="safe-padding">
    <div class="acea-row row-middle footer-wrap">
      <div
        v-for="(item, index) in footerList"
        :key="index"
        class="custom-footer-item"
        :class="{ on: item.url === $route.path }"
        @click="goPage(item,index)"
      >
        <div class="foot_img"><img :src="(item.url === $route.path ? item.icon1 : item.icon2)"></div>
        <div>{{ item.name }}</div>
        <div
          v-if="item.type==3"
          class="custom-footer-item-children"
          :class="[item.isActive?'active':'']"
        >
          <div
            class="custom-footer-item-children-item"
            v-for="(vo,vo_i) in item.children"
            :key="vo_i"
            @click.self="goPage(vo)"
          >{{vo.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHomeData } from "@api/public";

export default {
  name: "Footer",
  props: {},
  data: function () {
    return {
      footerList: [
        {
          name: "首页",
          icon1:  require('@assets/images/icon_zhuye_cur.png'),
          icon2:  require('@assets/images/icon_zhuye.png'),
          url: "/",
          type: 1,
        },
        {
          name: "吹风机",
          icon1:  require('@assets/images/icon_cfj_cur.png'),
          icon2:  require('@assets/images/icon_cfj.png'),
          url: "/detail/80",
          type: 1,
          // isActive: false,
        },
        {
          name: "支架",
          icon1:  require('@assets/images/icon_zj_cur.png'),
          icon2:  require('@assets/images/icon_zj.png'),
          url: "",
          type: 3,
          isActive: false,
          children:[
            {
              name:'支架',
              type:1,
              id:77,
              url:'/detail/77',
            },
            {
              name:'立架',
              type:1,
              id:81,
              url:'/detail/81',
            },
          ]
        },
        // {
        //   name: "吸尘器",
        //   icon1:  require('@assets/images/icon_xcq.png'),
        //   icon2:  require('@assets/images/icon_xcq.png'),
        //   url: "/detail/79",
        //   type: 1,
        // },
        {
          name: "配件",
          icon1:  require('@assets/images/icon_pj.png'),
          icon2:  require('@assets/images/icon_pj.png'),
          url: "/fitting_list",
          type: 1,
          new:true
        },
        {
          name: "我的",
          icon1:  require('@assets/images/icon_user_cur.png'),
          icon2:  require('@assets/images/icon_user.png'),
          url: "/user",
          type: 1,
        },
      ],
    };
  },
  mounted: function () {
    getHomeData().then(res => {
        // this.footerList[2].url = '/detail/'+res.data.likeInfo[2].id
        // this.footerList[3].url = '/detail/'+res.data.likeInfo[1].id
    })
  },
  watch: {},
  methods: {
    goPage(vol,index){
      this.footerList.forEach((item,i)=>{
        if(item.type === 3 && index !== i){
          item.isActive = false
        }
      })
      if (vol.type == 1) {
        this.$router.push({path:vol.url})
      } else{
        this.footerList[index].isActive = !this.footerList[index].isActive
      }
    },
  },
  computed: {},
};
</script>
<style scoped>

</style>
